export * from './control-panel-detail.page';
